import { endpoint, API_BASE_URL, COMPANY_API_ENDPOINTS } from '@/utils/api/endpoints';
import { Company } from '@/models/company.model';
import axios from 'axios';

export default {
	namespaced: true,

	state: {
		company: new Company(),
	},

	getters: {
		selectedCompany(state) {
			return state.company;
		},
	},

	mutations: {
		SET_COMPANY(state, data) {
			state.company = new Company(data);
			window.localStorage.setItem('selectedCompany', data.id);
		},
	},

	actions: {
		SetCompany({ commit }, company) {
			commit('SET_COMPANY', company);
			commit('SET_COMPANY', company, { root: true });
		},

		async LoadCompany({ rootGetters }, id = null) {
			if (!id) id = rootGetters.company.id;

			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.COMPANY, {
					params: {
						id,
					},
				});

				const { data } = await axios.get(url);
				if (!data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load company' });

				return data.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async InviteCompanyUser({ rootGetters }, { email }) {
			if (!email) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });
			if (!rootGetters.company.id) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });

			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.INVITE, {
					params: {
						id: rootGetters.company.id,
					},
				});
				const { data } = await axios.post(url, { email });
				if (!data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to create or load invite' });

				return data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async CancelCompanyUserInvite({ rootGetters }, inviteId) {
			if (!inviteId) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });

			if (!rootGetters.company.id) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });

			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.CANCEL_INVITE, {
					params: {
						companyId: rootGetters.company.id,
						inviteId,
					},
				});
				const { data } = await axios.patch(url);
				if (!data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to cancel invite' });

				return data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async GetPendingCompanyUserInvites({ rootGetters }) {
			if (!rootGetters.company.id) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });

			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.PENDING_INVITES, {
					params: {
						id: rootGetters.company.id,
					},
				});
				const { data } = await axios.get(url);
				if (!data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load pending invites' });

				return data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async CreateCompany(_, company) {
			if (!company) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });

			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.COMPANIES);
				const { data } = await axios.post(url, company);
				if (!data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to create or load invite' });

				return data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async RedeemCreditRequest({ rootGetters }) {
			if (!rootGetters.company.id) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });

			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.COMPANY_REDEEM_CREDIT, {
					params: {
						id: rootGetters.company.id,
					},
				});
				const { data } = await axios.post(url);
				if (!data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to create or load invite' });

				return data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async LoadCompanyTawkHash({ rootGetters }) {
			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.TAWK_HASH_REQUEST, {
					params: {
						id: rootGetters.company.id,
					},
				});
				const results = await axios.post(url, null, { headers: { Authorization: rootGetters.jwtToken } });
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async RequestPermanentPlacement({ rootGetters }, placementDetails) {
			try {
				const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.REQUEST_PERMANENT_PLACEMENT, {
					params: {
						id: rootGetters.company.id,
					},
				});
				const results = await axios.post(url, placementDetails, { headers: { Authorization: rootGetters.jwtToken } });
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},
	},
};
